import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/base/ComicCard';
import SEOHead from '@/components/base/SEOHead';
import { comics, categories } from '@/mocks/comics';
import { testimonials } from '@/mocks/testimonials';

export default function Home() {
  const featuredComics = comics.slice(0, 3);
  const latestComics = comics.slice(3, 7);
  const popularComics = comics.slice(0, 6);

  const homepageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '虚空韩漫网',
    url: 'http://txtjly.com/',
    description: '虚空韩漫网集免费韩漫、漫画大全、在线漫画和好看的韩国漫画于一体，致力于打造最全面的韩漫数字图书馆。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://txtjly.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOHead
        title="虚空韩漫网 - 免费韩漫_漫画大全_在线漫画_好看的韩国漫画"
        description="虚空韩漫网集免费韩漫、漫画大全、在线漫画和好看的韩国漫画于一体，致力于打造最全面的韩漫数字图书馆。每日更新，高清画质，畅享阅读。"
        keywords="虚空韩漫网,免费韩漫,漫画大全,在线漫画,好看的韩国漫画,韩漫推荐,韩国漫画在线阅读"
        schema={homepageSchema}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[520px] md:h-[620px] flex items-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20stylized%20Korean%20manhwa%20illustration%20background%2C%20abstract%20ink%20wash%20style%20with%20warm%20earthy%20tones%2C%20flowing%20dynamic%20lines%2C%20soft%20gradient%20of%20cream%20and%20terracotta%20colors%2C%20elegant%20texture%2C%20subtle%20comic%20panel%20elements%2C%20no%20characters%2C%20artistic%20abstract%20composition%2C%20high%20resolution&width=1800&height=800&seq=hero-bg-home&orientation=landscape"
            alt="虚空韩漫网 背景"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

          <div className="relative z-10 w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight animate-fade-in-up">
                免费韩漫大全
              </h1>
              <p className="font-heading text-xl md:text-3xl lg:text-4xl font-semibold text-background-50/90 mt-3 animate-fade-in-up animation-delay-100">
                在线漫画数字图书馆
              </p>
              <p className="mt-5 text-sm md:text-base text-background-50/70 max-w-2xl mx-auto leading-relaxed animate-fade-in-up animation-delay-200">
                汇聚韩国漫画精华，每日更新热门韩漫。恋爱、奇幻、动作、悬疑 —— 你想要的韩漫都在这里。
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animation-delay-300">
                <Link
                  to="/category/romance"
                  className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  开始阅读
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3 border border-background-50/40 text-background-50 font-medium rounded-full text-sm hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 px-4 md:px-6 pb-6">
            <div className="max-w-5xl mx-auto">
              <div className="bg-background-50/10 backdrop-blur-md rounded-2xl p-4 md:p-6">
                <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex flex-col items-center gap-2 p-3 rounded-xl hover:bg-background-50/15 transition-colors cursor-pointer group"
                    >
                      <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/20 text-background-50 group-hover:bg-primary-500 transition-colors">
                        <i className={`${cat.icon} text-lg md:text-xl`}></i>
                      </div>
                      <span className="text-xs md:text-sm text-background-50 font-medium whitespace-nowrap">
                        {cat.name}
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Popular Comics Section */}
        <section className="py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
                  热门推荐
                </h2>
                <p className="mt-2 text-sm text-foreground-500">
                  千万读者共同选择的最受欢迎韩漫
                </p>
              </div>
              <Link
                to="/category/romance"
                className="text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="md:col-span-1">
                <ComicCard comic={popularComics[0]} variant="large" />
              </div>
              <div className="md:col-span-2 grid grid-cols-2 gap-4">
                {popularComics.slice(1, 5).map((comic) => (
                  <ComicCard key={comic.id} comic={comic} variant="compact" />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Latest Updates Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-foreground-950">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10">
              <div>
                <span className="inline-block px-4 py-1.5 border border-background-50/30 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                  本周更新
                </span>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mt-4">
                  最新更新
                </h2>
              </div>
              <Link
                to="/category/action"
                className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
              >
                查看更多 <i className="ri-arrow-right-line text-sm"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
              {latestComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} variant="compact" />
              ))}
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
                分类浏览
              </h2>
              <p className="mt-3 text-sm text-foreground-500">
                按你喜欢的类型发现精彩韩漫
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {categories.map((cat, index) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group cursor-pointer"
                >
                  <div className="bg-background-100 rounded-xl p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:bg-primary-50">
                    <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-2xl bg-background-200 group-hover:bg-primary-100 transition-colors">
                      <i className={`${cat.icon} text-2xl text-foreground-700 group-hover:text-primary-600 transition-colors`}></i>
                    </div>
                    <h3 className="mt-4 font-heading text-sm font-semibold text-foreground-900">
                      {cat.name}
                    </h3>
                    <p className="mt-2 text-xs text-foreground-500 line-clamp-2">
                      {cat.description}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Comics Grid */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
                  精选佳作
                </h2>
                <p className="mt-2 text-sm text-foreground-500">
                  编辑精选的高品质韩国漫画
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {featuredComics.concat(comics.slice(6, 9)).map((comic) => (
                <ComicCard key={comic.id} comic={comic} variant="compact" />
              ))}
            </div>

            <div className="mt-10 text-center">
              <Link
                to="/category/fantasy"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                浏览全部漫画 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <span className="inline-block px-4 py-1.5 border border-foreground-300 text-foreground-600 text-xs font-medium rounded-full whitespace-nowrap">
                读者评价
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mt-4">
                漫友们怎么说
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((t) => (
                <div key={t.id} className="bg-background-100 rounded-xl p-6">
                  <div className="flex items-center gap-3">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <div className="flex items-center gap-0.5 mt-0.5">
                        {Array.from({ length: t.rating }).map((_, i) => (
                          <i key={i} className="ri-star-fill text-xs text-accent-500"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                    "{t.content}"
                  </p>
                  <p className="mt-3 text-xs text-foreground-400">{t.date}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
                常见问题
              </h2>
            </div>

            <div className="space-y-3">
              {[
                { q: '虚空韩漫网的漫画都是免费的吗？', a: '是的！虚空韩漫网上的所有韩国漫画均免费提供在线阅读，无需付费订阅，畅享全部内容。' },
                { q: '漫画更新频率是怎样的？', a: '我们每日更新热门连载韩漫，确保读者能够第一时间阅读到最新章节。热门作品通常每周更新2-3话。' },
                { q: '支持手机阅读吗？', a: '虚空韩漫网完美适配手机、平板和电脑端，无论使用什么设备都能获得流畅舒适的阅读体验。' },
                { q: '如何找到我喜欢的漫画类型？', a: '您可以通过首页的分类导航进入不同漫画类型页面，也可以在搜索功能中按关键词查找喜欢的漫画。' },
              ].map((faq, index) => (
                <details key={index} className="group bg-background-50 rounded-xl">
                  <summary className="px-6 py-4 cursor-pointer flex items-center justify-between text-foreground-900 font-medium text-sm list-none">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-lg transition-transform group-open:rotate-180"></i>
                  </summary>
                  <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}